import { render, staticRenderFns } from "./NewCampaignPopup.vue?vue&type=template&id=1918006d&scoped=true"
import script from "./NewCampaignPopup.vue?vue&type=script&lang=js"
export * from "./NewCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=1918006d&prod&scoped=true&lang=css&external"
import style1 from "./NewCampaignPopup.vue?vue&type=style&index=1&id=1918006d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1918006d",
  null
  
)

export default component.exports